import { ItemRow } from '@/features/gate/v1/kit'
import { C } from '@/features/gate/v1/style'
import { tr } from '@/features/gate/v1/text'
import { bagsAt, siteOf, type StoreState } from '../projection'
import { IconBox } from './bits'
import { SIcon } from './icons'

/**
 * या सूची से चुनें: this godown's bays and spots to tap, for when the label can't be scanned (no
 * camera, a torn label, or two places printed with the same number). Each row shows the bags there.
 */
export function PlacePicker({
  state,
  onPick,
}: {
  state: StoreState
  onPick: (locationId: string) => void
}) {
  const places = [...state.locations.values()]
    .filter(
      (l) =>
        l.active &&
        (l.level === 'BAY' || l.level === 'POSITION') &&
        siteOf(state, l.id)?.id === state.siteId,
    )
    .sort((a, b) => a.code.localeCompare(b.code))
  if (places.length === 0) return null
  return (
    <>
      <b style={{ fontSize: 17 }}>{tr('store.v1.placeList.title')}</b>
      {places.map((l) => (
        <ItemRow
          key={l.id}
          onClick={() => onPick(l.id)}
          padding="8px 10px"
          border={C.border}
          lead={
            <IconBox
              icon={l.role === 'CONVENTIONAL' ? 'redtie' : 'godown'}
              size={44}
              iconSize={26}
            />
          }
          title={l.name ?? l.code}
          line={
            <span style={{ fontSize: 15, color: C.muted }}>
              {tr('store.v1.placeList.line', { code: l.code, count: bagsAt(state, l.id).length })}
            </span>
          }
          right={
            <span style={{ color: C.acc, display: 'flex' }}>
              <SIcon name="next" size={24} sw={2.5} />
            </span>
          }
        />
      ))}
    </>
  )
}
